<template>
    <footer>
        <section class="section_footer_black">
            <div class="container_footer_nav">
                <img
                    src="@/assets/logo_white.png"
                    class="logo_header"
                />
                <div class="box_footer_nav">
                    <router-link
                        to="/"
                        class="technologies_text footer_nav"
                    >
                        ГЛАВНАЯ
                    </router-link>
                    <router-link
                        to="/about"
                        class="technologies_text footer_nav"
                    >
                        О КОМПАНИИ
                    </router-link>
                    <router-link
                        to="/vacancies"
                        class="technologies_text footer_nav"
                    >
                        СОИСКАТЕЛЯМ
                    </router-link>
                    <router-link
                        to="/employees"
                        class="technologies_text footer_nav"
                    >
                        СОТРУДНИКАМ
                    </router-link>
                    <!-- <router-link
                        to="/"
                        class="technologies_text footer_nav"
                    >
                        КОНТАКТЫ
                    </router-link> -->
                </div>
            </div>
            <div class="footer_box_contacts">
                <a
                    href="mailto:lk@tdshkurenko.ru"
                    class="technologies_text footer_nav"
                >
                    lk@tdshkurenko.ru
                </a>
                <!-- <a
                    href="tel:+74993509027"
                    class="technologies_text footer_nav"
                >
                    +7 (499) 350-90-27
                </a> -->
            </div>
        </section>
        <section class="section_footer_white">
            <p class="subtext_services footer_text">
                ОГРН 1035507025619 / ИНН 5504086398
            </p>
            <a
                href="/privacy-policy.html"
                class="subtext_services footer_text text_decoration_underline"
                target="_blank"
                rel="noopener noreferrer"
            >
                ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ
            </a>
        </section>
    </footer>
</template>

<script>
export default {
    components: {},
};
</script>
